import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onUnmounted } from 'vue';
import { roomService, AI_TASK, AITaskEvent } from '../../services';


export default /*#__PURE__*/_defineComponent({
  __name: 'AISubtitles',
  setup(__props) {

const rawSubtitleText = ref('');
const subtitleLines = computed(() =>
  rawSubtitleText.value.split('\n').filter(item => item)
);

let subtitleTimeout: ReturnType<typeof setTimeout> | null = null;

const resetSubtitleTimeout = () => {
  if (subtitleTimeout) {
    clearTimeout(subtitleTimeout);
  }

  subtitleTimeout = setTimeout(() => {
    rawSubtitleText.value = '';
  }, 3000);
};

const handleAISubtitles = (data?: AITaskEvent[AI_TASK.TRANSCRIPTION_TASK]) => {
  if (!data) return;
  rawSubtitleText.value = data.subtitleText.value;
  resetSubtitleTimeout();
};

roomService.aiTask.on(AI_TASK.TRANSCRIPTION_TASK, handleAISubtitles);

onUnmounted(() => {
  roomService.aiTask.off(AI_TASK.TRANSCRIPTION_TASK, handleAISubtitles);
});

return { __sfc: true,rawSubtitleText, subtitleLines, subtitleTimeout, resetSubtitleTimeout, handleAISubtitles }
}

})